export function canAccess(userRoles, allowedRoles) {
  if (!userRoles || !allowedRoles) return false;
  return userRoles.some(role => allowedRoles.includes(role.name));
}